export const FETCH_REQUEST_LEAVES = "FETCH_REQUEST_LEAVES";
export const FETCH_REQUEST_LEAVE = "FETCH_REQUEST_LEAVE";
export const EDIT_REQUEST_LEAVE = "EDIT_REQUEST_LEAVE";
